import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import modsFactoryApi from '../../api/modsFactoryApi';
import modsfactoryUrls from "../../configs/mods_factory/modsfactoryUrls";
import { MainSkinInterface } from "../../store/mods_factory/mainSkinsSlice";

const PREFIX = 'mods_factory';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: modsfactoryUrls.mainSkinPath(value.id),
    thumbnail_url: modsfactoryUrls.remoteUrl(value.thumbnail_url),
    mcpack_url: modsfactoryUrls.remoteUrl(value.mcpack_url),
    mcpack_second_url: modsfactoryUrls.remoteUrl(value.mcpack_second_url)
  };
}

const mainSkinsEntity = new schema.Entity(
  'main_skins',
  {},
  {
    processStrategy
  }
);

const mainSkinEntity = new schema.Entity(
  'main_skin',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<any, { main_skin: MainSkinInterface }>(response.data.main_skin, mainSkinEntity);
  return normalized.entities;
}

export const fetchMainSkins = createAsyncThunk(
  `${PREFIX}_mainSkins/fetchMainSkins`,
  async (params: object = {}) => {
    const response    = await modsFactoryApi.get(`/onesky/main_skins`, { params })
    const normalized  = normalize<any, { main_skins: { [key: string]: MainSkinInterface } }>(response.data.main_skins, [mainSkinsEntity]);

    return {
      main_skins: normalized.entities?.main_skins || {},
      ids: normalized.result,
      count: response.data.meta?.total_count
    };
  }
);

export const fetchMainSkin = createAsyncThunk(
  `${PREFIX}_mainSkins/fetchMainSkin`,
  async (id: number | string) => {
    const response = await modsFactoryApi.get(`/onesky/main_skins/${id}`);
    return normalizeInstance(response);
  }
);

export const createMainSkin = createAsyncThunk(
  `${PREFIX}_mainSkins/createMainSkin`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await modsFactoryApi.post(`/onesky/main_skins`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateMainSkin = createAsyncThunk(
  `${PREFIX}_mainSkins/updateMainSkin`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await modsFactoryApi.patch(`/onesky/main_skins/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyMainSkin = createAsyncThunk(
  `${PREFIX}_mainSkins/destroyMainSkin`,
  async (id: number) => {
    const response = await modsFactoryApi.delete(`/onesky/main_skins/${id}`);
    return response.data;
  }
);
